type ApiResponseType = ApiSchema['Listing'];

/**
 * Loads listing details for a specific listingId from a local json file
 * (temporary, until API delivers all data). Request & Response structure are exactly the same
 */
export default async function apiLoadLocalListingDetails<T extends ListingDetails>(listingId: string | undefined): Promise<ApiResult<T>> {
    try {
        const result = await $fetch<ApiResponseType>(`/data/listings/${listingId}.json`);

        return {
            ok: true,
            data: transformListingDetails(result) as T,
            warnings: [],
        };
    }
    catch (error) {
        throw new Error('Failed to load esav local listing details', { cause: error });
    }
}
